import { Fragment, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import Footer from 'components/common/Footer';
import Loader from 'components/common/Loader';
import { PopUpSessionAutoLogOutScheme } from 'components/common/PopUpScheme/PopUpSessionAutoLogOutScheme';
import { setIsSuccessLoginStatus } from 'services/authUtils';
import { INITIAL_PATH_AFTER_LOGIN } from 'routes/constants';

const logoPath = process.env.REACT_APP_LOGO_PATH;

// `isSessionTimeoutEnabled` — for the pages of an already logged-in user that live in this layout instead of
// ApplicationLayout (the "Choose Your Account Type" page of "Register as a Customer", TRN-7583): the inactivity
// watcher is mounted by the layouts, so without it the session never expired while such a page stayed open.
// The pages of a visitor who isn't logged in (login, registration, password recovery) must not have it.
const AuthorizationLayout = ({ authStore, isSessionTimeoutEnabled = false }) => {
  useEffect(() => {
    if (!authStore.isLoading && authStore.isLoginSuccess && authStore.isPinSuccess) {
      setIsSuccessLoginStatus(true);
      window.location.replace(INITIAL_PATH_AFTER_LOGIN);
    }
  }, [authStore.isLoading, authStore.isLoginSuccess, authStore.isPinSuccess]);

  return (
    <div className={'page authorization'}>
      {!authStore.isLoading && authStore.isLoginSuccess && authStore.isPinSuccess ? (
        <Loader className={'application-loader'} />
      ) : (
        <Fragment>
          <main className={'content'}>
            {isSessionTimeoutEnabled && <PopUpSessionAutoLogOutScheme />}
            <a
              href={process.env.REACT_APP_LINK_HOME_PAGE}
              target={'_blank'}
              rel={'noreferrer'}
              className={'icon-logo-wrapper'}
            >
              <img src={logoPath} alt={'Logo'} className={'icon-logo'} />
            </a>
            <Outlet />
          </main>
          <Footer />
        </Fragment>
      )}
    </div>
  );
};

AuthorizationLayout.propTypes = {
  authStore: MobXPropTypes.observableObject,
  isSessionTimeoutEnabled: PropTypes.bool
};

export default inject((stores) => ({
  authStore: stores.authStore
}))(observer(AuthorizationLayout));
